import React from 'react';
import { FiverrDarkLogo } from '@fiverr-private/visuals';
import { Link } from '@fiverr-private/typography';

interface Props {
    href: string;
}

export const Logo = ({ href }: Props) => (
    <Link href={href} height="fit-content">
        <FiverrDarkLogo size="sm" />
    </Link>
);
